import React, { useState } from 'react';
const History_ListItem = ({ title, RedeemDetails }) => {
const [isActive, setIsActive] = useState(false);
  return (
    <div className="w-100 tc f4-l f7-m f8-ns center ma1">
      <div className="tc pa2 pa3-l br2 w-100 flex " style={{backgroundColor:'#8796af' }}  onClick={() => setIsActive(!isActive)}>
        <div className=" tc f4-l f7-m f8-ns w-100 center tr " style={{color:'#bad1d7'}}>
               {title}
        </div>
        <div className="pr2 b f8 w-10 f6-m tr" style={{color:'#bad1d7'}} >{isActive ? '-' : '+'}</div>
      </div>
      {isActive &&  <div className=" w-100  ba pb2 b--solid b--black-30">
            {RedeemDetails.map((RedeemDetails, i) => (
              <li className="list lh-copy  bl-0 bt-0   br-0 b--solid w-100 " key={i} style={{color:'#0d304d'}} >
              <div className="w-100 flex center pa2 pa3-l p">
              <div className="w-50 f4-l f7-m f8-ns  pl3 tl pl6-l " style={{color:'#bad1d7'}}>{RedeemDetails.title}</div>
               <div className="w-50 f4-l f7-m f8-ns pl4 tl " style={{color:'#eabf69'}}>{RedeemDetails.Status}</div>
              </div>
              </li>
            ))}
          </div>}
          
    </div>
  );
};

export default History_ListItem;